// 국내 휴대폰 번호 입력 유틸 — 앰버서더 대시보드(가입/로그인/계약 정보)에서 사용.
// 서버는 숫자만("01012345678")을 받는다: 표시용 하이픈 포맷과 전송용 정규화를 분리한다.

// 입력값을 숫자만 남기고 11자리로 제한해 3-4-4 하이픈 포맷으로 변환 (예: "01012345678" → "010-1234-5678")
export const formatPhoneNumberInput = (value: string): string => {
  const numbers = value.replace(/\D/g, "").slice(0, 11);
  if (numbers.length < 4) return numbers;
  if (numbers.length < 8) return `${numbers.slice(0, 3)}-${numbers.slice(3)}`;
  return `${numbers.slice(0, 3)}-${numbers.slice(3, 7)}-${numbers.slice(7)}`;
};

// 하이픈 포맷 기준 국내 휴대폰(01x) 유효성 — 최종 검증은 서버(libphonenumber)가 수행한다
export const isValidKrMobile = (value: string): boolean =>
  /^01[016789]-\d{3,4}-\d{4}$/.test(value);

// 전송용 정규화 — 숫자만 남긴다
export const normalizePhoneNumber = (value: string): string =>
  value.replace(/\D/g, "");
